import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "paymentMethod", "serviceTypeRadio", "quoteTypeRadio", "serviceType"];

  connect() {
    this.toggleSubmitButton();
    this.addListeners();
    this.handleLockIn();
  }

  handleLockIn() {
    if (this.hasServiceTypeRadioTarget) {
      this.serviceTypeRadioTargets.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.paymentMethodTarget.classList.remove("hidden");
        });
      });
    } else {
      this.paymentMethodTarget.classList.remove("hidden"); // happens for light, show payment options straight away
    }

    if (this.hasQuoteTypeRadioTarget) {
      this.quoteTypeRadioTargets.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.serviceTypeTargets.forEach((block) => block.classList.add("hidden"));
          document.getElementById(radio.value).classList.remove("hidden");
        });
      });
    }
  }

  addListeners() {
    this.formTarget.addEventListener("change", () => {
      this.toggleSubmitButton();
    });
  }

  toggleSubmitButton() {
    const submitButton = this.formTarget.querySelector("button[type='submit']");
    const allValid = Array.from(this.formTarget.elements).every((el) => {
      if (!el.willValidate) return true;
      if (el.closest(".hidden")) return true;
      return el.validity.valid;
    });
    submitButton.disabled = !allValid;
  }
}
